<template>
    <div class="inspection-page">
      <div class="left-form" ref="madeForm">
        <avue-form ref="AvueForm" :option="formOption" v-model="detailForm"  @submit="submit" ></avue-form>
      </div>
    </div>
  </template>
  
  <script>
  import { disposeDetail } from '@/basic-common/util/common.js';
  import { getUserList } from "../../../api";
  export default {
    props: {
      formData: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        detailForm:{},
        formOption: {
          ...this.$store.state.formOption,
          menu: false,
          span: 24,
          submitBtn:false,
          emptyBtn:false,
          edit: true,
          column: [
          { 
              label: '指挥名称', 
              prop: 'organizationName',
              type: 'input',
              maxlength: 20,
            },
            {
            label: "负责人名称",
            prop:'responsiblePersonId',
            dataType: 'string',
            type: "select",
            multiple: false,
            dicData: [],
            props: {
              label: "name",
              value: "id"
            },
          },
            { 
              label: '负责人电话', 
              prop: 'responsiblePersonPhone',
              type: 'input',
              maxlength: 11,
              placeholder: '请输入负责人联系电话',
              rules: [
                { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
              ]
            },
            { 
              label: '职责', 
              prop: 'responsibility',
              type: 'textarea',
              maxlength: 500,
              rows: 4,
              placeholder: '请输入职责描述'
            },
          ],
        },
      };
    },
    watch: {
      formData: {
        handler (val) {
          this.detailForm = this.normalizeFormData(val)
        },
        deep: true,
        immediate: true
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        disposeDetail(this.$refs.madeForm)
        getUserList().then(({ data }) => {
        this.findObject(this.formOption.column, 'responsiblePersonId').dicData = data
      })
      },
      normalizeFormData (data = {}) {
        return {
          ...data,
          responsiblePersonPhone: data.responsiblePersonPhone || data.responsiblePersonContact || '',
          responsibility: data.responsibility || data.mainDuties || ''
        }
      },
      submit() {
        return {
          ...this.detailForm,
          responsiblePersonName:this.detailForm.$responsiblePersonId,
        }
        
        
 
    },
    }
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-form__menu {
    display: none;
  }
  .inspection-page {
    display: flex;
    padding: 20px;
    gap: 20px;
    background-color: #fff;
  }
  .left-form {
    flex: 1;
  }
  </style>
